import { render, staticRenderFns } from "./GitHubMD.vue?vue&type=template&id=7e2cf5c2&scoped=true"
import script from "./GitHubMD.vue?vue&type=script&lang=js"
export * from "./GitHubMD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2cf5c2",
  null
  
)

export default component.exports